import getCarrier from 'helpers/getCarrier';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import SendVerificationCodeForm from '../../components/SendVerificationCodeForm';
import VerifyCodeForm from '../../components/VerifyCodeForm';

const verificationTimer = 60000; // timer in ms
const getTimerTime = (endTime) => {
  const dateNow = Date.now();
  if (!endTime || dateNow >= endTime) {
    return null;
  }

  return Math.round((endTime - dateNow) / 1000);
};
class VerificationCode extends Component {
  state = {
    isSentVerificationCode: false,
    targetMethod: undefined,
    verifyCodeSuccessMsg: '',
    timers: {},
    sendingCode: false,
    selectedMethod: '',
  };

  changeSelectedMethod = (event, value) => {
    const { timers } = this.state;
    const key = value;
    const prevTimer = timers[key];

    if (Date.now() >= prevTimer) {
      this.setState({
        selectedMethod: key,
        timers: { ...timers, [key]: null },
      });
    } else {
      this.setState({ selectedMethod: key });
    }
  };

  handleSendCode = (values) => {
    const { sendVerificationCode, subId, sub } = this.props;

    this.setState({
      isSentVerificationCode: false,
      targetMethod: values.target_method,
      verifyCodeSuccessMsg: '',
      sendingCode: true,
    });

    let attrs = { ...values };
    const carrier = getCarrier(sub);
    // add sub_carrier for tf api
    if (carrier === 'tracfone') {
      attrs.sub_carrier = sub.sub_carrier;
    }

    return sendVerificationCode(subId, attrs)
      .then(() => {
        this.setState({
          isSentVerificationCode: true,
          targetMethod: values.target_method,
          verifyCodeSuccessMsg: '',
          timers: {
            ...this.state.timers,
            [attrs.target_method]: Date.now() + verificationTimer,
          },
        });
      })
      .finally(() => {
        this.setState({
          sendingCode: false,
        });
      });
  };

  onTimerEnd = () => {
    this.setState((state) => ({
      timers: { ...state.timers, [state.selectedMethod]: null },
    }));
  };

  handleVerifyCode = (values) => {
    const { verifyVerificationCode, subId } = this.props;

    this.setState({
      verifyCodeSuccessMsg: '',
    });

    return verifyVerificationCode(subId, values).then(() => {
      this.setState({
        verifyCodeSuccessMsg: 'Code successfully verified',
      });
    });
  };

  render() {
    const { user, sub, subId, isBusiness } = this.props;
    const {
      targetMethod,
      timers,
      selectedMethod,
      isSentVerificationCode,
      verifyCodeSuccessMsg,
      sendingCode,
    } = this.state;
    const selectedTimer = timers[selectedMethod];
    const timerTime = getTimerTime(selectedTimer);

    if (isBusiness) {
      return <Redirect to={`/quick/subscriptions/${subId}/view`} />;
    }

    return (
      <div>
        <h2>Send Verification Code</h2>
        <SendVerificationCodeForm
          onSubmit={this.handleSendCode}
          isSuccess={isSentVerificationCode}
          sendingCode={sendingCode}
          changeSelectedMethod={this.changeSelectedMethod}
          timerTime={timerTime}
          onTimerEnd={this.onTimerEnd}
          user={user}
          sub={sub}
        />
        <h2>Verify Code</h2>
        <VerifyCodeForm
          onSubmit={this.handleVerifyCode}
          isSentVerificationCode={isSentVerificationCode}
          initialValues={{ target_method: targetMethod }}
          successMsg={verifyCodeSuccessMsg}
        />
      </div>
    );
  }
}

export default VerificationCode;
